import {Badge, Nav} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {NavLink} from 'react-router'
import React from 'react'
import {isBool, isFunction} from '../Tools/TypeOf'

interface NavItemCustomInterface {
  badge?: number | boolean;
  classnameItem?: string;
  classnamelink?: string;
  disabled?: boolean;
  eventKey: string;
  iconName?: string;
  iconSize?: string;
  isActive?: Function | boolean;
  onClick?: Function;
  title: string;
  toPathname: string;
  toState?: Object;
}

const NavItemCustom = ({
  badge,
  eventKey,
  classnameItem,
  classnamelink,
  disabled,
  iconName,
  iconSize,
  isActive = true,
  title,
  toPathname,
  toState,
  onClick,
}: NavItemCustomInterface) => {
  const handleNotActive = (isActive) =>
    (((isFunction(isActive) && !isActive()) ||
      (isBool(isActive) && !isActive)) &&
      'not-active') ||
    ''

  const handleLinkClassname = (classnamelink, isActive) => {
    return `${classnamelink} ${
      isActive !== undefined && handleNotActive(isActive)
    }`.trim()
  }

  return (
    <Nav.Item className={classnameItem}>
      <Nav.Link
        as={NavLink}
        key={eventKey}
        to={{
          pathname: `/${toPathname}`,
          state: toState,
        }}
        onClick={(evt) => {
          if (!isActive) {
            evt.preventDefault()
          }

          if (onClick) {
            onClick(evt)
          }
        }}
        disabled={disabled}
        active={false}
        className={(() => handleLinkClassname(classnamelink, isActive))()}>
        {iconName && (
          <FontAwesomeIcon
            icon={iconName}
            color="white"
            className="mr-1"
            size={iconSize}
          />
        )}
        {badge ? (
          <span className="d-flex flex-row align-items-center">
            {title}
            <Badge bg="danger" className="ml-1 text-decoration-none">
              {badge}
            </Badge>
          </span>
        ) : (
          title
        )}
      </Nav.Link>
    </Nav.Item>
  )
}

export default NavItemCustom
